/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Recovery_LeadInputs */

const en_features_recovery_lead = /** @type {(inputs: Features_Recovery_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know what has recovered.`)
};

const pl_features_recovery_lead = /** @type {(inputs: Features_Recovery_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiesz, co już odpoczęło.`)
};

/**
* | output |
* | --- |
* | "Know what has recovered." |
*
* @param {Features_Recovery_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_recovery_lead = /** @type {((inputs?: Features_Recovery_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Recovery_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_recovery_lead(inputs)
	return en_features_recovery_lead(inputs)
});